import New from './AccountsNew'
import Main from './AccountsMain'
import Show from './AccountsShow'
import Edit from './AccountsEdit'

const Accounts = {
  New,
  Main,
  Show,
  Edit,
}

export default Accounts
